import Cookies from 'js-cookie'
const name = 'userName';
const sit = 'sit'
const token = 'token'

export const getName = () => Cookies.get(name);
export const getSit = () => Cookies.get(sit);
export const getToken = () => Cookies.get(token)
export const removeToken = () => Cookies.remove(token, {domain: '.mzdata.top'});